import * as ngCore from '@angular/core'
import { TypeAsserter } from '@attain-apps/type-guards'
import { ComponentStore } from '@ngrx/component-store'

import * as state from '../../../../../../../../state'
import { widgetRef } from '../../../../../../../../state/mosaic/dev/widgets/gql/fragments'
import * as componentStore from '../../component-store'

import { State } from './state'

/**
 * Maintains the org chart
 */
@ngCore.Injectable()
export class Store extends ComponentStore<State> {
  /** @see {@link state.mosaic.treeEditor.orgChart.Feature} */
  public readonly treeEditorFeature = ngCore.inject(
    state.mosaic.treeEditor.Feature,
  )
  /** @see {@link componentStore.Widget} */
  public readonly widgetStore = ngCore.inject(componentStore.Widget)

  /** @see {@link State.chartId} */
  public readonly chartIdSg = this.selectSignal(_state => _state.chartId)

  /**
   * __NOTE__: Throws if {@link State.chartId} is `undefined` so use with **caution**!
   *
   * @see {@link chartIdSg}
   */
  public readonly validChartIdSg = ngCore.computed(
    (chartId = this.chartIdSg()) => {
      TypeAsserter.assertIsNotNullish(chartId)

      return chartId
    },
  )

  /** TODO:  */
  public hasProposalSg = ngCore.computed(
    (widgetRefId = this.widgetStore.refIdSg()) =>
      this.treeEditorFeature.selectors.hasProposal({ widgetRefId }).asSignal(),
  )

  constructor() {
    super(State.INITIAL)
  }
}
